import React, { forwardRef } from 'react';
import asArray from '@grebban/array-utils/asArray';
import styled from '@grebban/style-system-react';

/**
 * This is a simple base component of an html5 video.
 */

const StyledVideo = styled('video')`
    width: 100%;
    height: 100%;
`;

const Video = ({ src, ...rest }, ref) => (
    <StyledVideo
        key={`${src}`}
        ref={ref}
        {...rest}
    >
        {asArray(src).map((source, i) => (
            <source
                key={`${typeof source === 'string' ? source : source.src || ''}_${i}`}
                src={typeof source === 'string' ? source : source.src || ''}
                type={source.type || ''}
            />
        ))}
    </StyledVideo>
);

export default forwardRef(Video);
